import React from 'react';
import translate from '@/utils/translate';
import type {CampaignPaidGigBriefItem} from '@/types/campaign';
import BriefItemHtml from '../../shared/BriefItemHtml';
import BriefSection from '../../shared/BriefSection';
import {getBriefItemByTitle} from '../../utils/briefItemFilters';

interface TermsAndConditionsProps {
  briefItems: CampaignPaidGigBriefItem[];
}

function TermsAndConditions({briefItems}: TermsAndConditionsProps) {
  const item = getBriefItemByTitle(briefItems, 'Terms and conditions');
  if (!item) {
    return null;
  }
  return (
    <BriefSection title={translate('Terms and conditions')}>
      <BriefItemHtml
        contentHtml={item.contentHtml}
        highlighted={item.highlighted}
      />
    </BriefSection>
  );
}

export default TermsAndConditions;
